import { Contact } from 'models/Contact';

export type EnterpriseContactsPeopleTable = Pick<
  Contact,
  'email' | 'phone' | 'preApproved' | 'existUser' | 'firstName' | 'companyName'
> &
  Record<'edit' | 'checkbox', string>;

export const TABLE_COLUMNS: Array<keyof EnterpriseContactsPeopleTable> = [
  'checkbox',
  'firstName',
  'email',
  'phone',
  'companyName',
  'preApproved',
  'existUser',
  'edit',
];

export const HEADING_TRANSLATIONS: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  firstName: 'name',
  email: 'email',
  phone: 'phone',
  preApproved: 'preApproved',
  existUser: 'resolveAccount',
  companyName: 'company',
};

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  firstName: 'sortName',
  email: 'email',
  phone: 'phone',
  companyName: 'companyName',
  preApproved: 'preApproved',
  existUser: 'existUser',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  checkbox: 20,
  edit: 70,
};
